module.exports = __webpack_public_path__ + "img/ruanbao8.771ec09d.jpg";